export type {
  CarrierDto,
  ConditionalRuleDto,
  ConditionalRulesDto,
} from "@babackapp/private-api-client/types";

export const createCarrierTagCondition = (
  tagValue: string,
): ConditionalRulesDto => ({
  operator: "AND",
  rules: [
    {
      id: "tags",
      type: "array",
      operator: "contains",
      value: tagValue,
    },
  ],
});

export const extractCarrierTagValue = (
  conditionalRules?: ConditionalRulesDto | null,
): string | null => {
  if (!conditionalRules?.rules?.length) return null;

  const tagRule = conditionalRules.rules.find(
    (rule: ConditionalRuleDto) =>
      rule.id === "tags" &&
      rule.type === "array" &&
      rule.operator === "contains",
  ) as ConditionalRuleDto | undefined;

  if (tagRule && typeof tagRule.value === "string") {
    return tagRule.value;
  }

  return null;
};
